import { Address } from '@31third/common';
import { BuyEntry } from '../model';
import { RebalancingAllocationEntryDto } from '../dto';

export class RebalancingAllocationEntryFactory {
  public static createAllocationEntryFromSellEntry(
    buyEntry: BuyEntry,
  ): RebalancingAllocationEntryDto {
    return this.createAllocationEntry(
      buyEntry.asset.token.address,
      buyEntry.proportion,
    );
  }

  public static createAllocationEntry(
    tokenAddress: Address,
    allocation: number,
  ): RebalancingAllocationEntryDto {
    const baseEntry = new RebalancingAllocationEntryDto();
    baseEntry.allocation = allocation;
    baseEntry.tokenAddress = tokenAddress;
    return baseEntry;
  }
}
